import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import userSettingsPlugin from '@backstage/plugin-app-module-user-settings';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import authModule from './modules/auth';

export default createApp({
  features: [catalogPlugin, navModule, homeModule, authModule, userSettingsPlugin],
});
